export default __webpack_public_path__ + "static/media/qr_code.18b4111f.svg";